"use strict";

var mobileMenuToggle = document.querySelector('.menu-toggle');
mobileMenuToggle.addEventListener('click', function (event) {
  event.preventDefault();
  document.body.classList.toggle('mobile-nav-open');
});